import React, { useState } from "react";
import {
  Bar,
  BarChart,
  CartesianGrid,
  Cell,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";

export const SEGMENT_SHARE = [
  { label: "Structural Repair / Retrofitting (Any Structure)", short: "Structural Repair", value: 25 },
  { label: "Structural Repair of Bridge / Flyover / Tunnels", short: "Bridge / Flyover", value: 15 },
  { label: "Structural Repair of DAM / Hydro Power Plant", short: "DAM / Hydro Power", value: 15 },
  { label: "Leakage Restoration (Any Structure)", short: "Leakage Restoration", value: 5 },
  { label: "Soil Stabilization / Ground Consolidation", short: "Soil Stabilization", value: 2 },
  { label: "Waterproofing (Any Structure)", short: "Waterproofing", value: 25 },
  { label: "Thermal Insulation", short: "Thermal Insulation", value: 3 },
  { label: "PU / Epoxy Flooring", short: "PU / Epoxy Flooring", value: 3 },
  { label: "Anticarbonation / Protective Coatings", short: "Protective Coatings", value: 3 },
  { label: "Expansion Joints Treatment", short: "Expansion Joints", value: 4 },
];

const COLORS = [
  "#1e6fcf",
  "#3b82f6",
  "#60a5fa",
  "#0ea5e9",
  "#0284c7",
  "#38bdf8",
  "#7dd3fc",
  "#0369a1",
  "#075985",
  "#aad4fa",
];

function ChartTooltip({ active, payload }) {
  if (!active || !payload?.length) return null;
  const { label, value } = payload[0].payload;
  return (
    <div className="rounded-lg border border-white/10 bg-[#0f2744]/95 px-3 py-2 shadow-xl backdrop-blur-sm max-w-[240px]">
      <p className="text-[11px] font-semibold text-white leading-snug">{label}</p>
      <p className="mt-1 text-sm font-black text-[#aad4fa]">{value}%</p>
    </div>
  );
}

export default function SegmentShareChart() {
  const [activeIndex, setActiveIndex] = useState(null);

  return (
    <div className="w-full h-[520px] sm:h-[560px]">
      <ResponsiveContainer width="100%" height="100%">
        <BarChart
          data={SEGMENT_SHARE}
          layout="vertical"
          margin={{ top: 4, right: 16, left: 4, bottom: 4 }}
          barCategoryGap="18%"
        >
          <CartesianGrid strokeDasharray="3 3" stroke="rgba(255,255,255,0.08)" horizontal={false} />
          <XAxis
            type="number"
            domain={[0, 25]}
            ticks={[0, 5, 10, 15, 20, 25]}
            tick={{ fill: "#94a3b8", fontSize: 11, fontFamily: "Plus Jakarta Sans, sans-serif" }}
            axisLine={{ stroke: "rgba(255,255,255,0.15)" }}
            tickLine={{ stroke: "rgba(255,255,255,0.15)" }}
            tickFormatter={(v) => `${v}%`}
          />
          <YAxis
            type="category"
            dataKey="short"
            width={130}
            tick={{ fill: "#cbd5e1", fontSize: 11, fontFamily: "Plus Jakarta Sans, sans-serif" }}
            axisLine={false}
            tickLine={false}
          />
          <Tooltip content={<ChartTooltip />} cursor={{ fill: "rgba(255,255,255,0.04)" }} />
          <Bar
            dataKey="value"
            radius={[0, 6, 6, 0]}
            barSize={22}
            onMouseEnter={(_, index) => setActiveIndex(index)}
            onMouseLeave={() => setActiveIndex(null)}
          >
            {SEGMENT_SHARE.map((entry, index) => (
              <Cell
                key={entry.label}
                fill={COLORS[index % COLORS.length]}
                fillOpacity={activeIndex === null || activeIndex === index ? 1 : 0.45}
              />
            ))}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}
